<template>
  <div class="content-box">
    <HconTitle subTitle="회사소개" subDescription="현대이지웰을 소개합니다."/>
    <div class="sub-wrapper block">
      <div class="company-wrap">
        <!-- 회사소개 영역 -->
        <section class="company-intro">
          <!-- 첫번째 영역 -->
          <article class="company-box">
            <div class="company-img"><img src="@/assets/images/pc/sub-hcon/img-introduce05.png" alt=""></div>
            <div class="company-text">
              <h4 class="company-title"><em>EZWEL</em>고객을 행복하게, 세상을 풍요롭게<br/>복지 시장의 <span class="text-teal">Market Leader</span></h4>
              <p class="company-desc">현대이지웰은 공공기관 및 민간기업 고객사를 대상으로<br/>
                '현대이지웰 복지몰'이라는 B2B 폐쇄몰을 운영하며,<br/>
                다양한 복지 서비스와 상품 콘텐츠를 제공하는 국내 대표 복지 플랫폼 기업입니다.</p>
              <p class="company-desc">최근에는 청년 취업지원 및 근속지원 등 정부의 공공복지사업, <br/>
                그리고 지역 경제 활성화를 위한 지역화폐몰 사업까지 사업 영역을 확장해 나가고 있습니다.</p>
              <div class="button-box jc-l">
                <NuxtLink to="//www.hyundaiezwel.com/renew/business/corporate01.ez" target="_blank" class="btn btn-outline md">복지 서비스 도입 문의</NuxtLink>
              </div>
            </div>
          </article>
          <!-- 두번째 영역 -->
          <article class="company-box reverse">
            <div class="company-img"><img src="@/assets/images/pc/sub-hcon/img-introduce06.png" alt=""></div>
            <div class="company-text">
              <h4 class="company-title"><em>NEW</em>새로운 가치, <br/><span class="text-teal">e쿠폰 사업</span>으로의 확장</h4>
              <p class="company-desc">현대이지웰은 디지털 전환 시대의 복지 혁신을 위해<br/>
                기업 고객이 쉽고 효율적으로 사용할 수 있는 e쿠폰(전자상품권) 플랫폼을 새롭게 선보입니다.<br/>
                본 서비스는 기업이 다양한 브랜드 쿠폰을 대량으로 발행·발송·정산할 수 있도록 지원하며, <br/>
                인사·마케팅·보상 등 각종 비즈니스 목적에 맞춘 맞춤형 쿠폰 솔루션을 제공합니다.</p>
              <p class="company-desc">이를 통해 기업은 관리 효율성을 높이고, 임직원 및 고객에게는<br/>더욱 빠르고 편리한 디지털 복지 경험을 제공할 수 있습니다.</p>
              <div class="button-box jc-l">
                <button type="button" class="btn btn-outline md" @click="handleEPartnerInquiry">e쿠폰 제휴 문의</button>
              </div>
            </div>
          </article>
          <!-- 세번째 영역 -->
          <article class="company-box">
            <div class="company-img"><img src="@/assets/images/pc/sub-hcon/img-introduce07.png" alt=""></div>
            <div class="company-text">
              <h4 class="company-title"><em>VISION</em>현대이지웰의 <span class="text-teal">비전</span></h4>
              <p class="company-desc">현대이지웰은 선택적 복지 시장의 Market Leader로서<br/>
                차별화된 복지 서비스와 디지털 상품 콘텐츠를 지속적으로 선도하며,<br/>
                고객의 가치를 창출하는 국내 최고의 토탈 복지 솔루션 기업으로<br/>
                성장해 나가겠습니다.</p>
            </div>
          </article>
          <!-- 네번째 영역 -->
          <article class="company-box reverse">
            <div class="company-img"><img src="@/assets/images/pc/sub-hcon/img-introduce08.png" alt=""></div>
            <div class="company-text">
              <dl class="company-info">
                <dt>회사명</dt>
                <dd>주식회사 현대이지웰</dd>
              </dl>
              <dl class="company-info">
                <dt>대표이사</dt>
                <dd>박종선</dd>
              </dl>
              <dl class="company-info">
                <dt>설립일</dt>
                <dd>2003년 3월 14일</dd>
              </dl>
              <dl class="company-info">
                <dt>상장일</dt>
                <dd>2013년 12월 27일</dd>
              </dl>
              <dl class="company-info">
                <dt>자본금</dt>
                <dd>119억원</dd>
              </dl>
              <dl class="company-info">
                <dt>발행주식수</dt>
                <dd>보통주 23,746,361주(액면가 500원)</dd>
              </dl>
              <dl class="company-info">
                <dt>사업영역</dt>
                <dd>기업복지, 공공복지, BPO, 모바일식권, 지역 소상공인 활성화 사업</dd>
              </dl>
              <dl class="company-info">
                <dt>종업원 수</dt>
                <dd>380명 <span class="fs14 text-lightgray">*2024년 말 기준</span></dd>
              </dl>
              <dl class="company-info">
                <dt>주소</dt>
                <dd>서울특별시 서대문구 충정로 23</dd>
              </dl>
            </div>
          </article>
        </section>
        <!-- 현대백화점그룹 개요 영역-->
        <section class="company-group">
          <div class="company-text">
            <h4 class="company-title"><em>Hyundai Department Store Group</em>현대백화점그룹 개요</h4>
            <p class="company-desc">현대백화점그룹은 1971년 설립 이후, 고객에게 신뢰받는 기업을 목표로 유통 사업과 패션, 종합식품, 토탈리빙, 미디어, <br/>
              렌탈, B2B, 건설장비, 뷰티/헬스에 이르기까지 사업영역을 확대하여 재계 그룹 순위 자산 기준 24위,<br/>
              순이익 기준 39위(*23년 발표 기준, 공기업 제외)인 종합생활문화기업으로 성장하였습니다.<br/>
              앞으로도 각 분야별 기존 사업의 경쟁력을 강화하고 미래 성장성이 높은 신규 사업으로의 진출을 적극 추진해 나갈 것입니다.</p>
          </div>
          <div class="company-img"><img src="@/assets/images/pc/sub-hcon/img-introduce02.png" alt=""></div>
        </section>
      </div>
      <!-- 버튼 영역 -->
      <div class="button-box mt54"><NuxtLink to="//www.hyundaiezwel.com/renew/main.ez" target="_blank" class="btn lg">회사 홈으로 이동</NuxtLink></div>
    </div>
  </div>
</template>
<script setup lang="ts">
import { useToast } from "vue-toast-notification";
import HconTitle from '@/components/com/HconComPCTitle.vue'
import { usePopup } from '@/composables/hconUsePopup';
import { ETC_CODE } from '@/constants/hconMessageConstants';

// pc/etc/company-introduction 브래드크럼 영역
definePageMeta({label:'회사소개'})

const {showAlert} = usePopup()

const toast = useToast()

// 이메일 클릭하면 복사
const handleCopy = () => {
  const textToCopy = "hcon@hyundaiezwel.com"
  navigator.clipboard.writeText(textToCopy);
  toast.success("이메일 복사되었습니다.")
};

// e쿠폰 제휴 문의 버튼 click 이벤트
const handleEPartnerInquiry = () => {
  showAlert({
    title: 'e쿠폰 제휴 문의 안내',
    message: ETC_CODE.ALT_HCON_9217 /*e쿠폰 제휴 관련하여 문의가 있으신 경우<br />아래 이메일로 보내주시면 확인 후 안내드리겠습니다.*/
  })
}

const clickHandler  = (e: MouseEvent) => {
  const target = e.target as HTMLElement
  if (target && target.id === 'copy-btn') {
    handleCopy()
  }
}

onMounted(() => {
  window.addEventListener('click', clickHandler)
})

onUnmounted(() => {
  window.removeEventListener('click', clickHandler)
})

</script>
<style lang="scss">
@use "@/assets/scss/pc/etc-hcon.scss" as *;
</style>